export const MODULES = '/module/'
export const MODULES_ALL = `${MODULES}all`
